var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Edit"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.37 6.28a4.36 4.36 0 0 1 6-.16l.17.16 3.18 3.18a4.36 4.36 0 0 1 .16 6l-.16.17-2.49 2.5a3 3 0 0 1-2.26.87 2.98 2.98 0 0 1-.7 1.52l-.15.16-13.44 13.44a3 3 0 0 1-1.92.87l-.2.01H8a3 3 0 0 1-3-2.82V27.44a3 3 0 0 1 .74-1.97l.14-.15 13.44-13.44a2.99 2.99 0 0 1 1.68-.85c-.03-.74.21-1.5.73-2.1l.15-.16 2.5-2.5ZM8 27.44V32h4.56L26 18.56 21.44 14 8 27.44ZM27.38 8c-.27.02-.55.12-.78.3l-.1.1-2.5 2.5 5.1 5.1 2.5-2.5.1-.1c.4-.5.4-1.21 0-1.71l-.1-.1-3.19-3.2-.1-.1c-.24-.17-.5-.27-.79-.29h-.14Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.790f3bf29ce7dca9195284f8733205d6.svg";
export { ForwardRef as ReactComponent };